import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface UnlinkedResultDismissDialogData {
  /** Shown so the clinician can see what they are dismissing. */
  patientLabel: string;
  specimenNumber?: string | null;
}

/**
 * Collects the dismissal reason. The server requires one, so the confirm button stays
 * disabled until something has actually been typed or picked.
 */
@Component({
  selector: 'app-unlinked-result-dismiss-dialog',
  templateUrl: './unlinked-result-dismiss-dialog.component.html',
  styleUrls: ['./unlinked-result-dismiss-dialog.component.scss']
})
export class UnlinkedResultDismissDialogComponent {
  readonly presetReasons: string[] = [
    'Not a patient of this practice',
    'Duplicate of a result already on file',
    'Sent to the wrong doctor',
    'Test result no longer relevant'
  ];

  selectedPreset = '';
  otherReason = '';

  constructor(
    public dialogRef: MatDialogRef<UnlinkedResultDismissDialogComponent, string | undefined>,
    @Inject(MAT_DIALOG_DATA) public data: UnlinkedResultDismissDialogData
  ) { }

  get reason(): string {
    if (this.selectedPreset && this.selectedPreset !== 'other') {
      return this.selectedPreset;
    }
    return this.otherReason.trim();
  }

  get canConfirm(): boolean {
    return this.reason.length > 0;
  }

  confirm(): void {
    if (!this.canConfirm) {
      return;
    }
    this.dialogRef.close(this.reason);
  }

  cancel(): void {
    this.dialogRef.close(undefined);
  }
}
